export const ProgressBar = ({current, total}: {current: number; total: number}) => (
  <div className="w-full">
    <div className="mb-1.5 text-right text-12 text-moss-grey-400">
      {current} / {total}
    </div>
    <div className="flex gap-1">
      {Array.from({length: total}).map((_, i) => (
        <div
          key={i}
          className={`h-0.5 flex-1 rounded-full transition-colors duration-300 ${
            i < current ? 'bg-green-neon' : 'bg-moss-grey-500'
          }`}
        />
      ))}
    </div>
  </div>
)
